// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import Cookies from 'js-cookie'

// Redux:
import { getPageData } from 'actions/page'
import { currentPage } from 'selectors/page'

class Content extends React.Component {
	constructor() {
		super()

		this.state = {
			pagePassword: '',
			pagePasswordError: false
		}
	}

	handleChangeInput = ( e ) => {
		const id = e.currentTarget.getAttribute( 'data-id' )

		this.setState( {
			[ id ]: e.currentTarget.value
		} )
	}

	handleSubmitPagePassword = ( e ) => {
		e.preventDefault()
		const form = e.currentTarget
		const { dispatch, page } = this.props
		const { pagePassword } = this.state

		if ( ! page ) {
			return
		}

		Cookies.set( `page_password_${page.slug}`, pagePassword )
		dispatch( getPageData( page.slug, 'page', false, false, true ) )
	}

	renderPasswordProtected = () => {
		const { pagePassword } = this.state

		return (
			<div className="content-body-inner">
				<div className="content-body-text">
					<div className="content-locked">
						<p>This content is password protected. To view it please enter the password below:</p>

						<form action="" onSubmit={ this.handleSubmitPagePassword }>
							<input type="hidden" name="action" value="safe_rescue_formidable_submit_form" />
							<input type="password" placeholder="Password" value={ pagePassword } data-id="pagePassword" onChange={ this.handleChangeInput } />

							<p>
								<button className="button" type="submit">Submit</button>
							</p>
						</form>
					</div>
				</div>
			</div>
		)
	}

	render() {
		const { page } = this.props

		if ( ! page ) {
			return null
		}

		const title = (
			<h1 dangerouslySetInnerHTML={ { __html: page.title.rendered } }></h1>
		)
		var subTitle

		if ( page.sub_title ) {
			subTitle = (
				<h2 dangerouslySetInnerHTML={ { __html: page.sub_title.rendered } }></h2>
			)
		}

		const contentBodyClass = page.content_full_width ? 'content-body-full' : 'content-body'
		let pageContent = page.content.rendered,
			intro

		if ( page.html_override ) {
			pageContent = page.html_override
		}

		if ( page.intro.rendered ) {
			intro = (
				<div className="content-intro" dangerouslySetInnerHTML={ { __html: page.intro.rendered } }></div>
			)
		}

		let contentInner

		if ( page.is_password_protected ) {
			contentInner = this.renderPasswordProtected()
		} else {
			contentInner = (
				<div className="content-body-inner">
					{ intro }

					<div className='content-body-text' dangerouslySetInnerHTML={ { __html: pageContent } }></div>

					{ page.notes.rendered &&
						<div className='content-notes' dangerouslySetInnerHTML={ { __html: page.notes.rendered } }></div>
					}
				</div>
			)
		}

		const content = (
			<div className="content-body-wrap">
				<div className={ contentBodyClass }>
					<div className="page-title">
						{ title }
						{ subTitle }
					</div>

					{ contentInner }
				</div>
			</div>
		)

		return (
			<div className="page-section">
				{ content }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: currentPage( state )
	}
}

export default connect( mapStateToProps )( Content )



// WEBPACK FOOTER //
// ./views/main/page/Content.jsx